import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { useLanguage } from '../../context/LanguageContext'
import { useTranslation } from 'react-i18next'
import { staggerContainer, fadeInUp } from '../../utils/animations'

export default function SubPagesGrid({ pages = [], currentSlug }) {
  const { localized } = useLanguage()
  const { t } = useTranslation()

  const items = pages.filter((p) => p.slug !== currentSlug)

  if (!items.length) return null

  return (
    <section className="border-t border-border bg-background py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={false}
          whileInView="visible"
          viewport={{ once: true, margin: '-80px' }}
          variants={staggerContainer}
        >
          <motion.h2 variants={fadeInUp} className="mb-2 text-2xl font-bold text-primary sm:text-3xl">
            {t('pages.exploreMore')}
          </motion.h2>
          <motion.p variants={fadeInUp} className="mb-10 max-w-2xl text-text/65">
            {t('pages.exploreMoreDesc')}
          </motion.p>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {items.map((page) => (
              <motion.div key={page.id || page.slug} variants={fadeInUp}>
                <Link
                  to={`/pages/${page.slug}`}
                  className="group flex h-full flex-col rounded-2xl border border-border bg-white p-6 shadow-sm shadow-primary/5 transition-all duration-300 hover:-translate-y-1 hover:border-secondary/40 hover:shadow-xl hover:shadow-primary/10"
                >
                  <h3 className="mb-3 text-lg font-bold text-primary transition-colors group-hover:text-accent">
                    {localized(page, 'title')}
                  </h3>
                  <p className="mb-6 flex-1 text-sm leading-relaxed text-text/65">
                    {localized(page, 'excerpt') || localized(page, 'title')}
                  </p>
                  <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent">
                    {t('buttons.readMoreAbout', { title: localized(page, 'title') })}
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1 rtl:rotate-180 rtl:group-hover:-translate-x-1" />
                  </span>
                </Link>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  )
}
